/**
 * @file components/Title/component.js
 * @copyright 2022 CBC/Radio-Canada. All rights reserved.
 *
 */

import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./styles/themes/default.module.scss";
/**
 * @component
 * This component was transferred from the Ocelot Component Library
 * Renders title text in a title tag
 */

const Title = ({ level: TitleTag, hidden = false, children }) => {
    const classes = classNames(styles.title, hidden === true ? "a11y" : "");

    return (
        <TitleTag className={classes} data-testid="title-tag">
            {children}
        </TitleTag>
    );
};

const LevelProps = PropTypes.oneOf(["h1", "h2", "h3", "h4"]);

Title.propTypes = {
    level: LevelProps.isRequired, // Determines the title tag
    hidden: PropTypes.bool, // Visually hides tag with an a11y tag, will be available to assistive technologies
    children: PropTypes.any, // Contents of the title tag
};

export default Title;
